import React, { FC } from 'react';

import {
  Stack,
  HStack,
  Text,
  Link,
  OrderedList,
  ListItem,
} from '@chakra-ui/react';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { HelpHeader } from 'components/DataDisplay/Utils/HelpHeader';
import { ThirdPartyIcon } from 'components/Icons';

import { customTheme } from '../../../../../../../../theme';

export const ManualOnboardingHelp: FC = () => {
  return (
    <Stack h="full" spacing={10}>
      <Stack px={2} spacing={6}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <Text fontWeight={600}>
            Review permissions that Ariksa needs to assess your cloud
            environment
          </Text>
        </HStack>
        <HStack align={'start'}>
          <HelpCount count={2} />
          <Stack spacing={4}>
            <HStack>
              <Text fontWeight={600}>Login to your AWS account</Text>
              <Link href="https://console.aws.amazon.com" target="_blank">
                <ThirdPartyIcon w={6} h={6} color="primary" />
              </Link>
            </HStack>
            <OrderedList
              pl={4}
              spacing={1}
              color={customTheme.colors.gray['300']}
            >
              <ListItem pl={4}>
                Create a cross-account IAM role that can be used by Ariksa to
                connect to your AWS account
              </ListItem>
              <ListItem pl={4}>
                Copy the ARN (AWS Resource Name) of the IAM role
              </ListItem>
              <ListItem pl={4}>
                Copy the External ID that you used. External IDs are typically
                unique for every vendor that has access to your cloud
                environment
              </ListItem>
            </OrderedList>
          </Stack>
        </HStack>
      </Stack>
    </Stack>
  );
};
